import SigliveServiceSSE from 'Service/sigliveServiceSSE';

const getHelpRequestOperatorStatus = async () => {
  const { data } = await SigliveServiceSSE({ method: 'GET', url: '/monitoring-operator/help/active' });

  return data?.data;
};

export default getHelpRequestOperatorStatus;
